var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.source
    ? _c(
        "yxtf-scrollbar",
        { attrs: { "wrap-class": _vm.wrapClass, "fit-height": true } },
        [
          _c("div", { staticClass: "g2-popover g2-label-popover" }, [
            _c("div", { staticClass: "g2-popover-title yxt-weight-5" }, [
              _c("div", { staticClass: "max-width-312 ellipsis" }, [
                _vm._v("\n        " + _vm._s(_vm.labelData.name) + "\n      "),
              ]),
            ]),
            _c(
              "ul",
              { staticClass: "g2-popover-list" },
              _vm._l(_vm.subSkills, function (item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "g2-popover-list_item",
                    class: { pb4: index + 1 !== _vm.subSkills.length },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "g2-popover-name maxWidth250 ellipsis" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              (item.skill && item.skill.name) || item.name
                            ) +
                            _vm._s(
                              _vm.levelFormatter(
                                Object.assign({}, item, {
                                  fieldsType: "combStandardLevel",
                                })
                              ) && ":"
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "g2-tooltip-value ml16" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.levelFormatter(
                              Object.assign({}, item, {
                                fieldsType: "combStandardLevel",
                              })
                            )
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
        ]
      )
    : _c("div", { staticClass: "radar-label-tooltip" }, [
        _c("div", { staticClass: "radar-label-tooltip__header ellipsis" }, [
          _vm._v(
            "\n    " +
              _vm._s(_vm.labelData.name) +
              "(" +
              _vm._s(_vm.subSkills.length) +
              ")\n  "
          ),
        ]),
        _c(
          "div",
          { staticClass: "radar-label-tooltip__skills clearfix flex" },
          _vm._l(_vm.subSkills, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "radar-label-tooltip__skill",
                class: { mr34: index !== _vm.subSkills.length - 1 },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "ellipsis mb12 color-gray-8 lh22 font-size-14",
                  },
                  [_vm._v("\n        " + _vm._s(item.name) + "\n      ")]
                ),
                _c(
                  "div",
                  _vm._l(_vm.legendFields, function (range, index1) {
                    return _c(
                      "div",
                      {
                        key: index1,
                        staticClass:
                          "radar-label-tooltip__level flex align-items-center color-gray-9 lh22 font-size-14",
                        class: { mt4: index1 !== 0 },
                      },
                      [
                        _c("i", {
                          staticClass: "flex-shrink-0",
                          style: {
                            "background-color": _vm.legendMap[range].color,
                          },
                        }),
                        _vm._v(_vm._s(_vm.legendMap[range].label)),
                        _c("span", { staticClass: "ellipsis maxWidth200" }, [
                          _vm._v(
                            _vm._s(
                              _vm.valueMap
                                ? _vm.valueMap(
                                    Object.assign({}, item, {
                                      fieldsType: range,
                                    }),
                                    true
                                  )
                                : item[range] || "0"
                            )
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            )
          }),
          0
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }